import { notify } from 'Components/Notify';
import history from '../history';

const isTokenStillValid = (parsedToken) => {
  const currentTime = Math.floor(Date.now() / 1000);
  return currentTime < parsedToken.exp;
};

const isUserAuthenticated = () => {
  const token = window.localStorage.getItem('IdentityToken');
  return token && token !== 'null' && isTokenStillValid(parseJWT(token));
};

const parseJWT = (jwtString) => JSON.parse(atob(jwtString.split('.')[1]));

const auth = {
  user: {},
  isAuthenticated: () => isUserAuthenticated(),
  isRefreshTokenActive: () => {
    const token = window.localStorage.getItem('RefreshToken');

    if (!token || token === 'null') return false;

    if (isTokenStillValid(parseJWT(token))) return true;

    const isPayingInvoiceByEmail =
      history.location.pathname === '/PayInvoice' ||
      history.location.pathname === '/PayInvoice/GetInvoice';
    if (!isPayingInvoiceByEmail && history.location.pathname !== '/login') {
      notify.error();
      return false;
    }

    return false;
  },
  getIdentityToken: () => window.localStorage.getItem('IdentityToken'),
  getRefreshToken: () => window.localStorage.getItem('RefreshToken'),
  getPrepaidHeaders: () => {
    return isUserAuthenticated()
    ? {}
    : {
        IdentityToken: window.localStorage.getItem('Invoice-IdentityToken'),
        RefreshToken: window.localStorage.getItem('Invoice-RefreshToken'),
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      };
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/helpers/auth.js